const links: Record<string, Record<string, string>> = {
  ReportClaim_MotorClaims: {
    "en-GB": "#",
    "da-DK": "https://minesider.if.dk/web/skader",
    "fi-FI": "#",
    "sv-FI": "#",
    "sv-SE": "#",
    "nb-NO": "#",
  },

  ReportClaim_PersonClaims: {
    "en-GB": "#",
    "da-DK": "https://minesider.if.dk/web/skader",
    "fi-FI": "#",
    "sv-FI": "#",
    "sv-SE": "#",
    "nb-NO": "#",
  },

  ReportClaim_PropertyClaims: {
    "en-GB": "#",
    "da-DK": "https://minesider.if.dk/web/skader",
    "fi-FI": "#",
    "sv-FI": "#",
    "sv-SE": "#",
    "nb-NO": "#",
  },

  ReportClaim_TravelClaims: {
    "en-GB": "#",
    "da-DK": "https://minesider.if.dk/web/skader",
    "fi-FI": "#",
    "sv-FI": "#",
    "sv-SE": "#",
    "nb-NO": "#",
  },

  ReportClaim_ExistingClaim: {
    "en-GB": "#",
    "da-DK": "#",
    "fi-FI": "#",
    "sv-FI": "#",
    "sv-SE": "https://minasidor.if.se/startsida/mina-skador/",
    "nb-NO": "https://minesider.if.no/mine-skader/",
  },

  ReportClaim_ExistingClaim_BannerLinkText: {
    "en-GB": "#",
    "da-DK": "#",
    "fi-FI": "#",
    "sv-FI": "#",
    "sv-SE": "#",
    "nb-NO": "https://www.if.no/privat/meld-skade",
  },
};

export default (cultureCode: string | null | undefined, id: string): string => {
  if (!cultureCode) {
    return "";
  }

  if (links[id] && links[id][cultureCode]) {
    return links[id][cultureCode];
  }

  return id;
};
